import React from 'react';
import PropTypes from 'prop-types';
import { appConfig as config } from 'roc-package-web-app-react/app/shared/universal-config';
import Helmet from 'react-helmet';
import getLeadText from '../utils/get-lead-text';

const formatAuthors = ({ authors }) =>
    authors.map((author) => ({
        '@type': 'Person',
        name: author.title,
    }));

const formatKeywords = ({ tags }) =>
    tags
        .map((tag) => tag.title)
        .join(' ')
        .toLowerCase();

const fallbackImage = () => {
    const { schemaOrg: { defaultImage } } = config;
    return defaultImage;
};

const formatImage = ({ promotionContent }) => {
    if (promotionContent.imageAssets === undefined) {
        return fallbackImage();
    }

    const { url: imageUrl } = promotionContent.imageAsset.urls[
        promotionContent.imageAsset.urls.length - 1
    ];

    return imageUrl;
};

const formatOrganization = () => {
    const { schemaOrg: { organization: schemaOrg } } = config;
    return schemaOrg;
};

/**
 * Based on http://schema.org/NewsArticle
 */
const SchemaOrgArticle = ({ article, type = 'NewsArticle' }) => {
    const {
        title: { value: headline },
        changes: { published: datePublished, updated: dateModified },
        clientProperties: { wordCount },
        section: { title: articleSection },
    } = article;
    const { baseUrl } = config;
    const authors = formatAuthors(article);
    const description = getLeadText(article);
    const keywords = formatKeywords(article);
    const image = formatImage(article);
    const publisher = formatOrganization();
    const url = `${baseUrl}/i/${article.id}`;

    const articleData = {
        '@context': 'http://schema.org',
        '@type': type,
        headline,
        datePublished,
        dateModified,
        wordCount,
        articleSection,
        description,
        keywords,
        image,
        publisher,
        author: authors,
        mainEntityOfPage: url,
    };
    const schema = {
        type: 'application/ld+json',
        innerHTML: JSON.stringify(articleData),
    };

    return <Helmet script={[schema]} />;
};

SchemaOrgArticle.defaultProps = {
    type: 'NewsArticle',
};

SchemaOrgArticle.propTypes = {
    article: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
    type: PropTypes.string, // eslint-disable-line react/forbid-prop-types
};

export default SchemaOrgArticle;



/** WEBPACK FOOTER **
 ** ./src/local-components/SchemaOrg.js
 **/